import { ILoadCompanyScreenData } from "../application/LoadCompany";
import { Company } from "../domain/Company";


export class VueLoadCompanyScreenData implements ILoadCompanyScreenData {
    company: Company;
    loading: boolean;
    show_found_popup: boolean;
    show_not_found_popup: boolean;

    constructor() {
        this.loading = true;
    }

    setCompany(company:Company) {
        this.company = company;
    }

    setLoading(value: boolean): void {
        this.loading = value;
    }

    setFound(value: boolean): void {
        this.show_found_popup = value;
    }
    
    setNotFound(value: boolean): void {
        this.show_not_found_popup = value;
    }
}